import InvitationRequestPage, {
  BatchInvitationRequestPage,
} from "../views/Pages/Invitation/InvitationRequestPage";
import UserSettings from "../views/UserSettings/UserSettingsPage";
import { BatchSigningPage } from "../signing/BatchSigningPage";
import {
  mapToCompaniesTab,
  mapToContactsTab,
  mapToSignaturesTab,
} from "../portfolio/portfolioDomain";
import HelpCenter from "../views/Pages/HelpCenter";
import { PortfolioShareholderPage } from "../portfolio/contacts/PortfolioShareholderPage";
import { AdminInfoPage, PortfolioContactsPage } from "../portfolio/contacts/contactsComponents";
import { PortfolioCompaniesPage } from "../portfolio/companies/companiesComponents";
import ResolveNoticeForShareholderPage from "../meetings/generalMeeting/ResolveNoticeForShareholderPage";
import { FollowUpSignaturesPage } from "../portfolio/followUp/FollowUpSignaturesPage";
import { observer } from "mobx-react";
import { useRootStore } from "../stores/RootStoreContext";
import { isUserRoute } from "./routes";
import { FollowUpDecisionsPage } from "../portfolio/followUp/FollowUpDecisionsPage";
import { CustomRoleDetails } from "../portfolio/contacts/customRoleComponents";
import { EnterpriseAccountPage } from "../enterpriseAccounts/EnterpriseAccountPage";
import { FollowUpCompanyInfoPage } from "../portfolio/followUp/FollowUpCompanyInfoPage";
import { FollowUpShareholdersPage } from "../portfolio/followUp/FollowUpShareholdersPage";

const UserRoutes = observer(() => {
  const rootStore = useRootStore();
  const route = rootStore.route && isUserRoute(rootStore.route) ? rootStore.route : undefined;
  switch (route?.name) {
    case "portfolio/companies-all":
      return (
        <PortfolioCompaniesPage
          portfolioType={"all-companies"}
          companiesTab={mapToCompaniesTab(route.params.tab)}
        />
      );
    case "portfolio/companies-admin":
      return (
        <PortfolioCompaniesPage
          portfolioType={"with-admin-role"}
          companiesTab={mapToCompaniesTab(route.params.tab)}
        />
      );
    case "portfolio/companies-board-member":
      return (
        <PortfolioCompaniesPage
          portfolioType={"with-board-role"}
          companiesTab={mapToCompaniesTab(route.params.tab)}
        />
      );
    case "portfolio/companies-shareholder":
      return (
        <PortfolioCompaniesPage
          portfolioType={"my-investments"}
          companiesTab={mapToCompaniesTab(route.params.tab)}
        />
      );
    case "portfolio/companies-instance":
      return (
        <PortfolioCompaniesPage
          portfolioType={"portfolio-instance"}
          portfolioId={route.params.portfolioId}
          companiesTab={mapToCompaniesTab(route.params.tab)}
        />
      );
    case "portfolio/follow-up-signatures-all":
      return (
        <FollowUpSignaturesPage
          portfolioType={"all-companies"}
          activeHeader={"follow-up"}
          signaturesTab={mapToSignaturesTab(route.params.signaturesTab)}
        />
      );
    case "portfolio/follow-up-matters-all":
      return <FollowUpDecisionsPage portfolioType={"all-companies"} tab={route.params.tab} />;
    case "portfolio/follow-up-companyinfo-all":
      return <FollowUpCompanyInfoPage portfolioType={"all-companies"} />;
    case "portfolio/follow-up/shareholders":
      return <FollowUpShareholdersPage portfolioType={"all-companies"} tab={route.params.tab} />;

    case "portfolio/follow-up-signatures-admin":
      return (
        <FollowUpSignaturesPage
          portfolioType={"with-admin-role"}
          activeHeader={"follow-up"}
          signaturesTab={mapToSignaturesTab(route.params.signaturesTab)}
        />
      );
    case "portfolio/follow-up-matters-admin":
      return <FollowUpDecisionsPage portfolioType={"with-admin-role"} tab={route.params.tab} />;
    case "portfolio/follow-up-companyinfo-admin":
      return <FollowUpCompanyInfoPage portfolioType={"with-admin-role"} />;
    case "portfolio/follow-up-shareholders-admin":
      return <FollowUpShareholdersPage portfolioType={"with-admin-role"} tab={route.params.tab} />;
    case "portfolio/follow-up-signatures-board-member":
      return (
        <FollowUpSignaturesPage
          portfolioType={"with-board-role"}
          activeHeader={"follow-up"}
          signaturesTab={mapToSignaturesTab(route.params.signaturesTab)}
        />
      );
    case "portfolio/follow-up-signatures-shareholder":
      return (
        <FollowUpSignaturesPage
          portfolioType={"my-investments"}
          activeHeader={"follow-up"}
          signaturesTab={mapToSignaturesTab(route.params.signaturesTab)}
        />
      );
    case "portfolio/follow-up-signatures-instance":
      return (
        <FollowUpSignaturesPage
          portfolioType={"portfolio-instance"}
          portfolioId={route.params.portfolioId}
          signaturesTab={mapToSignaturesTab(route.params.tab)}
          activeHeader={"follow-up"}
        />
      );
    case "portfolio/follow-up-matters-instance":
      return (
        <FollowUpDecisionsPage
          portfolioType={"portfolio-instance"}
          portfolioId={route.params.portfolioId}
          tab={route.params.tab}
        />
      );
    case "portfolio/follow-up-companyinfo-instance":
      return (
        <FollowUpCompanyInfoPage
          portfolioType={"portfolio-instance"}
          portfolioId={route.params.portfolioId}
        />
      );
    case "portfolio/follow-up-shareholders-instance":
      return (
        <FollowUpShareholdersPage
          portfolioType={"portfolio-instance"}
          portfolioId={route.params.portfolioId}
          tab={route.params.tab}
        />
      );
    case "portfolio/contacts-all":
      return (
        <PortfolioContactsPage portfolioType={"all-companies"} tab={route.params.contactsTab} />
      );
    case "portfolio/contacts-admin":
      return (
        <PortfolioContactsPage portfolioType={"with-admin-role"} tab={route.params.contactsTab} />
      );
    case "portfolio/contacts-instance":
      return (
        <PortfolioContactsPage
          portfolioType={"portfolio-instance"}
          portfolioId={route.params.portfolioId}
          tab={mapToContactsTab(route.params.contactsTab)}
        />
      );
    case "portfolio/shareholder-all":
      return (
        <PortfolioShareholderPage
          shareholderId={route.params.shareholderId}
          portfolioType={"all-companies"}
          activeHeader={"contacts"}
          activeTab={route.params.activeTab!}
        />
      );
    case "portfolio/shareholder-instance":
      return (
        <PortfolioShareholderPage
          shareholderId={route.params.shareholderId}
          portfolioType={"portfolio-instance"}
          portfolioId={route.params.portfolioId}
          activeHeader={"contacts"}
          activeTab={route.params.activeTab!}
        />
      );
    case "portfolio/shareholder-admin":
      return (
        <PortfolioShareholderPage
          shareholderId={route.params.shareholderId}
          portfolioType={"with-admin-role"}
          activeHeader={"contacts"}
          activeTab={route.params.activeTab!}
        />
      );
    case "portfolio/shareholder-board-member":
      return (
        <PortfolioShareholderPage
          shareholderId={route.params.shareholderId}
          portfolioType={"with-board-role"}
          activeHeader={"contacts"}
          activeTab={route.params.activeTab!}
        />
      );
    case "portfolio/contacts-admins-all":
      return (
        <AdminInfoPage
          externalId={route.params.externalId}
          activeHeader={"contacts"}
          portfolioType={"all-companies"}
        />
      );
    case "portfolio/contacts-admins-admin":
      return (
        <AdminInfoPage
          externalId={route.params.externalId}
          activeHeader={"contacts"}
          portfolioType={"with-admin-role"}
        />
      );
    case "portfolio/contacts-admins-instance":
      return (
        <AdminInfoPage
          externalId={route.params.externalId}
          portfolioId={route.params.portfolioId}
          activeHeader={"contacts"}
          portfolioType={"portfolio-instance"}
        />
      );
    case "portfolio/contacts/custom-role":
      return (
        <PortfolioContactsPage
          portfolioType={"all-companies"}
          tab={"custom-role"}
          customRoleId={route.params.customRoleId}
        />
      );
    case "portfolio/contacts-admins/custom-role":
      return (
        <PortfolioContactsPage
          portfolioType={"with-admin-role"}
          tab={"custom-role"}
          customRoleId={route.params.customRoleId}
        />
      );
    case "portfolio/contacts-instance/custom-role":
      return (
        <PortfolioContactsPage
          portfolioType={"portfolio-instance"}
          tab={"custom-role"}
          portfolioId={route.params.portfolioId}
          customRoleId={route.params.customRoleId}
        />
      );
    case "portfolio/custom-role-details":
      return (
        <CustomRoleDetails
          customRoleId={route.params.customRoleId}
          externalId={route.params.externalId}
          portfolioType={"all-companies"}
        />
      );
    case "portfolio-admins/custom-role-details":
      return (
        <CustomRoleDetails
          customRoleId={route.params.customRoleId}
          externalId={route.params.externalId}
          portfolioType={"with-admin-role"}
        />
      );
    case "portfolio-instance/custom-role-details":
      return (
        <CustomRoleDetails
          customRoleId={route.params.customRoleId}
          externalId={route.params.externalId}
          portfolioId={route.params.portfolioId}
          portfolioType={"portfolio-instance"}
        />
      );
    case "help-center":
      return <HelpCenter portfolioType={"all-companies"} />;
    case "portfolio/help-center-all":
      return <HelpCenter portfolioType={"all-companies"} isPortfolioPage />;
    case "portfolio/help-center-admin":
      return <HelpCenter portfolioType={"with-admin-role"} isPortfolioPage />;
    case "portfolio/help-center-board-member":
      return <HelpCenter portfolioType={"with-board-role"} isPortfolioPage />;
    case "portfolio/help-center-shareholder":
      return <HelpCenter portfolioType={"my-investments"} isPortfolioPage />;
    case "portfolio/instance-help-center":
      return (
        <HelpCenter
          portfolioType={"portfolio-instance"}
          isPortfolioPage
          portfolioId={route.params.portfolioId}
        />
      );
    case "invitation-request":
      return <InvitationRequestPage invitationRequestId={route.params.invitationRequestId} />;
    case "batch-invitation-request":
      return <BatchInvitationRequestPage batchId={route.params.batchId} />;
    case "user/settings":
      return <UserSettings />;
    case "signing":
      return <BatchSigningPage signingMethod={route.params.signingMethod} />;
    case "notice-for-shareholder":
      return <ResolveNoticeForShareholderPage documentId={route.params.documentId} />;
    case "enterprise-account":
      return <EnterpriseAccountPage id={route.params.id} />;
    default:
      return null;
  }
});

export default UserRoutes;
